import { UserCard, UserCardSkeleton } from '@/components/custom';
import { useUsers } from '../hooks';
import { cn } from '@/lib/utils';

const gridClasses = cn(
  'grid',
  'grid-cols-1 gap-4',           // 1 column on mobile (very small)
  'min-[400px]:grid-cols-2',    // 2 columns from 400px
  'lg:grid-cols-3',             // Stays at 3 columns even on large screen (avoids reducing width)
  'xl:grid-cols-4',             // Max 4 columns on very large screens
  '2xl:grid-cols-4'
);

const DataGrid = () => {
  const { users, isFetching } = useUsers();

  if (isFetching) {
    return (
      <div className={gridClasses}>
        {[...Array(12)].map((_, i) => (
          <UserCardSkeleton key={i} className="w-full" />
        ))}
      </div>
    );
  }

  if (!users || users.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-muted-foreground">
        <p>Aucun utilisateur trouvé.</p>
      </div>
    );
  }

  return (
    <div className={gridClasses}>
      {users.map((user) => (
        <UserCard 
          key={user._id} 
          user={user} 
          className='w-full' 
        />
      ))}
    </div>
  );
};

export default DataGrid;
